<template>
    <v-card outlined class="my-5 mx-1"
    max-width="400"
    flat
  >
    <!-- color="grey lighten-4" -->
    <v-card-title class="text-center">
    TITLE
    </v-card-title>

    <v-sheet color="transparent">
      <v-sparkline
        :key="String(avg)"
        :line-width="10"
        :value="points"
        auto-draw
        type="bar"
        color="primary"
      ></v-sparkline>
    </v-sheet>
  </v-card>
</template>
<script>
export default {
  props: {
    intervals: {
      type: Array,
      required: false,
      default: undefined
    }
  },
  data() {
    return {
      checking: false,
      heartbeats: [],
      points: []
    }
  },
    computed: {
      avg () {
        const sum = this.heartbeats.reduce((acc, cur) => acc + cur, 0)
        const length = this.heartbeats.length

        if (!sum && !length) return 0

        return Math.ceil(sum / length)
      },
    },

    created () {
      this.takePulse(false)
      this.genPoints()
      console.log("points", this.points)
    },

    methods: {
      genPoints() {
          for (var i=0; i < this.intervals.length; i++) {
              this.points.push(this.intervals[0].load_kw)
          }
      },
      heartbeat () {
        return Math.ceil(Math.random() * (120 - 80) + 80)
      },
      async takePulse (inhale = true) {
        this.checking = true

        inhale && await exhale(1000)

        this.heartbeats = Array.from({ length: 20 }, this.heartbeat)

        this.checking = false
      },
    },
  }
</script>